/*
 * Module for the Insurance Carrier Change job criteria page
 */
rs.module("content/jobs/criteria/insurancecarrierchange",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, backendUrls) {

            var criteria = $.js(jsSelectors.criteria);

            var insuranceTypeSelect = criteria.js(jsSelectors.insuranceTypeSelect);
            var insuranceTypeHiddenInput = criteria.js(jsSelectors.insuranceTypeHiddenInput);
            var terminatingInsuranceCarrierSelect = criteria.js(jsSelectors.terminatingInsuranceCarrierSelect);
            var terminatingInsuranceCarrierHiddenInput = criteria.js(jsSelectors.terminatingInsuranceCarrierHiddenInput);
            var replacementInsuranceCarrierSelect = criteria.js(jsSelectors.replacementInsuranceCarrierSelect);
            var replacementInsuranceCarrierHiddenInput = criteria.js(jsSelectors.replacementInsuranceCarrierHiddenInput);
            var deductionTerminationDate = criteria.js(jsSelectors.deductionTerminationDate);
            var deductionTerminationDateHiddenInput = criteria.js(jsSelectors.deductionTerminationDateHiddenInput);
            var deductionEffectiveDate = criteria.js(jsSelectors.deductionEffectiveDate);
            var deductionEffectiveDateHiddenInput = criteria.js(jsSelectors.deductionEffectiveDateHiddenInput);
            var coverageTerminationDate = criteria.js(jsSelectors.coverageTerminationDate);
            var coverageTerminationDateHiddenInput = criteria.js(jsSelectors.coverageTerminationDateHiddenInput);
            var coverageEffectiveDate = criteria.js(jsSelectors.coverageEffectiveDate);
            var coverageEffectiveDateHiddenInput = criteria.js(jsSelectors.coverageEffectiveDateHiddenInput);
            var areCoveragesLoadedInput = criteria.js(jsSelectors.areCoveragesLoadedInput);
            var loadReplacementCoveragesLink = criteria.js(jsSelectors.loadReplacementCoveragesLink, { required: false });
            var resetSelectionLink = criteria.js(jsSelectors.resetSelectionLink, {required: false});
            var requiredError = criteria.js(jsSelectors.requiredError);
            var loadingSpinner = criteria.js(jsSelectors.loadingSpinner);
            var replacementCoveragesGridContainer = criteria.js(jsSelectors.replacementCoveragesGridContainer);

            // Get Select Helpers for selects where we're updating options and properties
            var insuranceTypeSelectHelper = selectHelper.getHelper(insuranceTypeSelect);
            var terminatingInsuranceCarrierSelectHelper = selectHelper.getHelper(terminatingInsuranceCarrierSelect);
            var replacementInsuranceCarrierSelectHelper = selectHelper.getHelper(replacementInsuranceCarrierSelect);

            // Filter replacement carriers now, in case we're being taken back to job criteria after error
            filterReplacementCarriers();

            // Register insuranceTypeSelect changed event
            insuranceTypeSelect.change(insuranceTypeChanged);

            // Register terminatingInsuranceCarrierSelect changed event
            terminatingInsuranceCarrierSelect.change(filterReplacementCarriers);

            // Register click load coverages link event
            loadReplacementCoveragesLink.click(loadCoverages);

            // Register click reset selection link event
            resetSelectionLink.click(resetSelection);

            // On insurance type change, handle population of associated insurance carriers
            function insuranceTypeChanged() {

                terminatingInsuranceCarrierSelectHelper.clearOptions();
                replacementInsuranceCarrierSelectHelper.clearOptions();

                if (insuranceTypeSelect.val()) {
                    terminatingInsuranceCarrierSelectHelper.setDisabled(false);
                    replacementInsuranceCarrierSelectHelper.setDisabled(false);

                    // since dropdowns share the same data, only make one call
                    $.getJSON(backendUrls.getInsuranceCarriers, { insuranceType: insuranceTypeSelect.val() }).done(function (options) {
                        terminatingInsuranceCarrierSelectHelper.replaceOptions(options, { withBlank: true });
                        replacementInsuranceCarrierSelectHelper.replaceOptions(options, { withBlank: true });
                    });
                }
                else {
                    // no insurance type selected, disable carrier selects
                    terminatingInsuranceCarrierSelectHelper.setDisabled(true);
                    replacementInsuranceCarrierSelectHelper.setDisabled(true);
                }
            }

            // filters the selected terminating carrier key from the list of available replacement carriers
            function filterReplacementCarriers() {

                // the terminating carrier select list will always have all available carriers
                var allCarriers = terminatingInsuranceCarrierSelectHelper.getOptions();

                // capture currently selected carriers
                var terminatingCarrier = terminatingInsuranceCarrierSelect.val();
                var replacementCarrier = replacementInsuranceCarrierSelect.val();

                // build the list of replacement carriers
                var replacementCarrierOptions = terminatingCarrier ? allCarriers.filter(option => option.value != terminatingCarrier) : allCarriers;

                // replace the options, maintaining previously selected replacement carrier
                replacementInsuranceCarrierSelectHelper.replaceOptions(replacementCarrierOptions).setValue(replacementCarrier);
            }

            // Reload the replacement coverages grid according to the currently entered field values
            function loadCoverages() {

                if (loadCoverageParamsValid()) {
                    areCoveragesLoadedInput.val(true);

                    // mark coverage fields disabled
                    insuranceTypeSelectHelper.setDisabled(true);
                    terminatingInsuranceCarrierSelectHelper.setDisabled(true);
                    replacementInsuranceCarrierSelectHelper.setDisabled(true);
                    deductionTerminationDate.prop('disabled', true);
                    deductionEffectiveDate.prop('disabled', true);
                    coverageTerminationDate.prop('disabled', true);
                    coverageEffectiveDate.prop('disabled', true);

                    // save coverage field values to corresponding hidden inputs - needed because model binding doesn't work on disabled inputs
                    insuranceTypeHiddenInput.val(insuranceTypeSelect.val());
                    terminatingInsuranceCarrierHiddenInput.val(terminatingInsuranceCarrierSelect.val());
                    replacementInsuranceCarrierHiddenInput.val(replacementInsuranceCarrierSelect.val());
                    deductionTerminationDateHiddenInput.val(deductionTerminationDate.val());
                    deductionEffectiveDateHiddenInput.val(deductionEffectiveDate.val());
                    coverageTerminationDateHiddenInput.val(coverageTerminationDate.val());
                    coverageEffectiveDateHiddenInput.val(coverageEffectiveDate.val());

                    visibility.setVisible(loadReplacementCoveragesLink, false);
                    visibility.setVisible(resetSelectionLink, true);
                    visibility.setVisible(requiredError, false);
                    visibility.setVisible(loadingSpinner, true);

                    // reload the grid
                    $.ajax({
                        url: backendUrls.getGridData,
                        data: {
                            terminatingInsuranceCarrierKey: terminatingInsuranceCarrierSelect.val(),
                            replacementInsuranceCarrierKey: replacementInsuranceCarrierSelect.val(),
                            insuranceType: insuranceTypeSelect.val(),
                            activeAsOfDate: coverageEffectiveDate.val()
                        },
                        dataType: "html",
                        success: function (data) {
                            replacementCoveragesGridContainer.html(data);
                            visibility.setVisible(loadingSpinner, false);
                        }
                    });
                }
                else {
                    visibility.setVisible(requiredError, true);
                }
            }

            // validate load coverage param values
            function loadCoverageParamsValid() {
                return insuranceTypeSelect.val() &&
                    terminatingInsuranceCarrierSelect.val() &&
                    replacementInsuranceCarrierSelect.val() &&
                    deductionTerminationDate.val() && deductionTerminationDate.valid() &&
                    deductionEffectiveDate.val() && deductionEffectiveDate.valid() &&
                    coverageTerminationDate.val() && coverageTerminationDate.valid() &&
                    coverageEffectiveDate.val() && coverageEffectiveDate.valid();
            }

            // Reset selection
            function resetSelection() {

                visibility.setVisible(loadingSpinner, true);

                // clear the coverages grid
                $.ajax({
                    url: backendUrls.clearGridData,
                    data: { },
                    dataType: "html",
                    success: function (data) {
                        replacementCoveragesGridContainer.html(data);
                        visibility.setVisible(loadingSpinner, false);

                        areCoveragesLoadedInput.val(false);

                        // re-open coverage fields for editing
                        insuranceTypeSelectHelper.setDisabled(false);
                        terminatingInsuranceCarrierSelectHelper.setDisabled(false);
                        replacementInsuranceCarrierSelectHelper.setDisabled(false);
                        deductionTerminationDate.prop('disabled', false);
                        deductionEffectiveDate.prop('disabled', false);
                        coverageTerminationDate.prop('disabled', false);
                        coverageEffectiveDate.prop('disabled', false);

                        visibility.setVisible(loadReplacementCoveragesLink, true);
                        visibility.setVisible(resetSelectionLink, false);
                        visibility.setVisible(requiredError, false);
                    }
                });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);